import CenterDetails from "../../DB/CenterDetails";
import "./ContactPageElementsCss/AllCentersSection.css";
import AnimatedText from "../../AnimatedText";
import { FaDirections } from "react-icons/fa";
import defaultStoreImg from "../../Assets/rbCenter.webp";
import { getAllCenter } from "../../api/api";
import { useState } from "react";
import { useEffect } from "react";

export default function AllCentersSection() {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [allCenter, setAllCenter] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  // api calling of allCenter

  useEffect(() => {
    fetchAllCenter();
  }, []);

  const fetchAllCenter = async () => {
    const payload = {};
    try {
      setLoading(true);
      const res = await getAllCenter(payload);
      if (res?.data?.status === "Succesful") {
        const apiData = res?.data?.data || [];

        if (apiData.length > 0) {
          //fetch data in setAllCenter
          setAllCenter(apiData);
          setMessage(""); // clear message when data found
        } else {
          // set empty array when data not found
          setAllCenter([]);
          setMessage("No data found"); // set message when data not found
        }
      } else {
        setAllCenter([]);
        setMessage("Problem on API");
      }

      console.log("res.data===>", res?.data);
    } catch (error) {
      console.error("Error fetching  faq data :", error);
    } finally {
      setLoading(false);
    }
  };

  // complete api caling

  console.log("center are ==>", allCenter);

  return (
    <div className="center-wrapper">
      <AnimatedText
        tag="h2"
        type="words"
        y={30}
        className="center-heading rb-title"
      >
        Other Branches
      </AnimatedText>

      <div className="center-grid">
        {allCenter.map((center, index) => (
          <div className="center-card" key={index}>
            <div className="center-img">
              <img
                src={center.centerImage || defaultStoreImg}
                alt={center.center_name}
              />
            </div>
            <div className="center-info">
              <h3>{center.center_name}</h3>
              <p className="addressP">
                <strong style={{ fontSize: "15px" }}>Address:</strong>
              </p>
              <div className="addressDiv">{center.center_address}</div>
              <br />
              {/* <p className="phoneNoDiv"><strong style={{fontSize:"15px"}}>Phone:</strong> - {center.phone}</p> */}
              {/* <p className="center-directions">Get Directions <span><FaDirections size={15} /></span></p> */}
              {/* <a
                                href={center.center_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="center-directions"
                            >
                                Get Directions <span><FaDirections size={15} /></span>
                            </a> */}
              <a
                href={
                  center.center_URL && center.center_URL.startsWith("http")
                    ? center.center_URL
                    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        center.center_address
                      )}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="center-directions"
              >
                Get Directions{" "}
                <span>
                  <FaDirections size={15} />
                </span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
